<script lang="ts">
  import Box from "@cohesionib/biblioteca/lib/Box";

  export let title: string | null = '';
  export let tooltip: boolean = false;
  export let onTooltipClick: () => void = () => {};
</script>

<style>
  #snapshot-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #snapshot-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    width: 100%;
  }
  .snapshot-children {
    width: 11em;
    padding: 1.5em 2em 1.5em 2em;
  }
</style>

<Box {title} {tooltip} {onTooltipClick}>
  <div id="snapshot-container">
    <div id="snapshot-content">
      <slot class="snapshot-children" />
    </div>
  </div>
</Box>
